import {
  Anchor,
  Box,
  Container,
  Grid,
  Group,
  Image,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link, Navigate } from "react-router";
import { useTutorialsAvailable } from "../hooks/useTutorialsAvailable";
import {
  img123Final2,
  img3AlPaso,
  imgBarCodeFinal2,
  imgEtiquetaRollo1,
  imgFiguras1,
  imgImagesFinal,
  imgLogoNoText128,
  imgPlanilla1,
  imgPrinter1,
  imgQrCodeNuevo,
  imgTxtPng,
  imgVariableDataFinal2,
} from "../shared/images";
import { NavBarContainer } from "./NavBarContainer";

const TUTORIALS = [
  { id: "tutorial1", key: "howToRoll", img: imgEtiquetaRollo1, yt: "w6QBhV_9e7Y" },
  { id: "tutorial2", key: "howToSheet", img: imgPlanilla1, yt: "sH4YqscfRUY" },
  { id: "tutorial3", key: "howTo3Across", img: img3AlPaso, yt: "E30J1z7au6U" },
  { id: "tutorial4", key: "howToText", img: imgTxtPng, yt: "4UFN-fR9_Ao" },
  { id: "tutorial5", key: "howToShapes", img: imgFiguras1, yt: "qRKJKZA1L_4" },
  { id: "tutorial6", key: "howToImages", img: imgImagesFinal, yt: "_u8rg4jWM7k" },
  { id: "tutorial7", key: "howToBarCodes", img: imgBarCodeFinal2, yt: "OVxsjZYXnYo" },
  { id: "tutorial8", key: "howToQR", img: imgQrCodeNuevo, yt: "W76gN1Ojmf4" },
  { id: "tutorial9", key: "howToPrint", img: imgPrinter1, yt: "Zq6Vum7V7xk" },
  { id: "tutorial10", key: "howToConsecutive", img: img123Final2, yt: "_-envn_bF9c" },
  { id: "tutorial11", key: "howToDataBase", img: imgVariableDataFinal2, yt: "UbAv2qGqNYM" },
  { id: "tutorial12", key: "howToBuy", img: imgLogoNoText128, yt: "Wj-FSfzyWyE" },
] as const;

export function TutorialsPage() {
  const { t } = useTranslation();
  const showTutorials = useTutorialsAvailable();

  if (!showTutorials) {
    return <Navigate to="/" replace />;
  }

  return (
    <NavBarContainer fullBleed showFooter>
      <Box
        style={{
          background:
            "linear-gradient(160deg, #fff8f2 0%, #ffffff 40%, #fff4eb 100%)",
        }}
        py={{ base: "xl", md: 48 }}
      >
        <Container size="lg">
          <Stack gap="xl">
            <Stack gap="xs" maw={560}>
              <Title order={1} c="charcoal.8">
                {t("fullTutorials.title")}
              </Title>
              <Text c="dimmed" size="lg">
                {t("fullTutorials.intro")}
              </Text>
            </Stack>

            <Grid>
              {TUTORIALS.map((tut) => {
                const title = t(
                  `fullTutorials.${tut.key}` as "fullTutorials.title",
                );
                return (
                  <Grid.Col key={tut.id} span={{ base: 12, md: 6 }} id={tut.id}>
                    <Stack
                      gap="md"
                      p="lg"
                      h="100%"
                      style={{
                        background: "white",
                        border: "1px solid var(--mantine-color-gray-2)",
                        borderRadius: "var(--mantine-radius-md)",
                        boxShadow: "0 8px 28px rgba(44, 45, 48, 0.05)",
                      }}
                    >
                      <Group gap="sm" wrap="nowrap" align="center">
                        <Image src={tut.img} alt="" w={48} h={48} fit="contain" />
                        <Title order={4} c="charcoal.8" lineClamp={2}>
                          {title}
                        </Title>
                      </Group>
                      <Box
                        style={{
                          position: "relative",
                          width: "100%",
                          paddingBottom: "56.25%",
                          borderRadius: "var(--mantine-radius-sm)",
                          overflow: "hidden",
                          background: "var(--mantine-color-charcoal-9)",
                        }}
                      >
                        <iframe
                          src={`https://www.youtube.com/embed/${tut.yt}`}
                          title={title}
                          allowFullScreen
                          style={{
                            position: "absolute",
                            inset: 0,
                            width: "100%",
                            height: "100%",
                            border: 0,
                          }}
                        />
                      </Box>
                    </Stack>
                  </Grid.Col>
                );
              })}
            </Grid>

            <Text size="sm" c="dimmed" ta="center">
              {t("fullTutorials.alsoDistributor")}{" "}
              <Anchor component={Link} to="/distributorportal" c="brand.7" fw={600}>
                {t("fullTutorials.distributorLink")}
              </Anchor>
            </Text>
          </Stack>
        </Container>
      </Box>
    </NavBarContainer>
  );
}
